import React from 'react';

import SpBasicTemplate from 'components/templates/SpBasicTemplate';
import SpConfItem from 'components/molecules/SpConfItem';

import './index.sp.scss';

const PresentSP = ({
  confList,

  onClickMainButton,
  showLoading,
  isApiError,
}) => (
  <div className="ConfSp">
    <SpBasicTemplate 
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      isApiError={isApiError}
      showLoading={showLoading}
    >
      {confList.map((conf)=>{
        const { text, children, questionMark, isCloseState, popUpTitle, popUpDetail } = conf;
        if(isCloseState) return '';
        return(
          <SpConfItem
            text={text}
            questionMark={questionMark}
            key={text}
            popUpTitle={popUpTitle}
            popUpDetail={popUpDetail}
          >
            {children}
          </SpConfItem>
        );
      })}
    </SpBasicTemplate>
  </div>
);

export default PresentSP;